'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementUtil = require('../elementUtil');

var _lodash = require('lodash');

var _ImageUploader = require('./ImageUploader');

var _ImageUploader2 = _interopRequireDefault(_ImageUploader);

var _ImageRenderer = require('./ImageRenderer');

var _ImageRenderer2 = _interopRequireDefault(_ImageRenderer);

var _ColorBar = require('../../components/colors/ColorBar');

var _ColorBar2 = _interopRequireDefault(_ColorBar);

var _Caption = require('../../components/caption/Caption');

var _Caption2 = _interopRequireDefault(_Caption);

var _ElementUserTag = require('../../user/userActivity/ElementUserTag');

var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);

var _ElementResizeHandle = require('../resizing/ElementResizeHandle');

var _ElementResizeHandle2 = _interopRequireDefault(_ElementResizeHandle);

var _elementCaptionUtil = require('../../components/caption/elementCaptionUtil');

var _gridUtils = require('../../utils/grid/gridUtils');

var _elementConstants = require('../../../common/elements/elementConstants');

var _imageConstants = require('../../../common/images/imageConstants');

require('./Image.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(props) {
    var element = props.element,
        gridSize = props.gridSize,
        inList = props.inList,
        tempSize = props.tempSize,
        elementEvents = props.elementEvents,
        isEditable = props.isEditable,
        isLocked = props.isLocked;


    var imageData = element.getIn(['content', 'image']);
    var hasImage = imageData || element.getIn(['attachment', 'data']);

    var displayElement = hasImage ? _react2.default.createElement(_ImageRenderer2.default, props) : _react2.default.createElement(_ImageUploader2.default, props);

    var colorName = element.getIn(['content', 'color']);
    var captionContent = (0, _elementCaptionUtil.getCaption)(element);
    var captionVisible = (0, _elementCaptionUtil.getShowCaption)(element);
    var imageElementSize = element.getIn(['content', 'width']);
    var imageWidth = tempSize || imageElementSize || _elementConstants.ELEMENT_DEFAULT_WIDTH;

    var defaultMaxWidth = (0, _lodash.min)([element.getIn(['content', 'image', 'width']), _imageConstants.IMAGE_WIDTH_MAX]);

    var transparent = !captionVisible && !colorName && !element.getIn(['content', 'showBackground']) && imageData && imageData.get('transparent');

    var classes = (0, _elementUtil.elementClassNames)('Image drag-handle', _extends({}, props, { transparent: transparent }));
    var showSpinner = element.getIn(['attachment', 'fetching']);

    return _react2.default.createElement(
        'div',
        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')), className: classes,
            style: (0, _gridUtils.getElementStyle)(imageWidth, gridSize, inList) }, elementEvents),
        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
        _react2.default.createElement(_ElementUserTag2.default, props),
        displayElement,
        _react2.default.createElement(_Caption2.default, _extends({}, props, {
            showDivider: !hasImage,
            textContent: captionContent,
            captionVisible: captionVisible })),
        _react2.default.createElement(_ElementResizeHandle2.default, _extends({}, props, { minWidth: _imageConstants.IMAGE_MIN_WIDTH_GRID,
            defaultMaxWidth: defaultMaxWidth,
            showHandle: !isLocked && isEditable && !showSpinner }))
    );
};

Image.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number,
    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    inList: _propTypes2.default.string,
    uploadImage: _propTypes2.default.func,
    isHovered: _propTypes2.default.bool,
    canDrop: _propTypes2.default.bool,
    tempSize: _propTypes2.default.number,
    className: _propTypes2.default.string,
    documentMode: _propTypes2.default.bool,
    elementEvents: _propTypes2.default.object,
    isEditable: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool
};

exports.default = Image;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/Image.js
// module id = 732
// module chunks = 0